const selectors = {
  toggle: '[data-toggle]',
  details: '[data-details]',
  text: '[data-text]:not([data-property])',
  section: '[data-section-type="product"]',
  giftNote: 'gift-note-handler',
  orDivider: 'product-personalisation + .ar-or-divider',
};

const attributes = {
  productFormID: 'data-product-form-id',
};

class ProductPersonalisation extends HTMLElement {
  constructor() {
    super();
    this.isToggled = false;
    this.colour = null;
    this.font = null;
    this.mainProductJson = null;
    this.personalisationOptionIndex = null;
    this.textPersonalisationValue = null;
    this.noPersonalisationValue = null;
    this.giftNoteElement = null;
    this.orDivider = null;
    // NOTE: This should really be part of the theme settings, but time wasn't on my side, so a future update needed.
    this.GIFT_NOTE_PRODUCT_ID = 6599663976527;
  }



  connectedCallback() {
    try {
      this.toggle = this.querySelector(selectors.toggle);
      this.details = this.querySelector(selectors.details);
      this.text = this.querySelector(selectors.text);
      this.container = this.closest(selectors.section);
      this.giftNoteElement = document.querySelector(selectors.giftNote);
      this.orDivider = document.querySelector(selectors.orDivider);

      const productFormId = this.getAttribute(attributes.productFormID);
      this.productForm = this.container.querySelector(`form#${productFormId}-personalisation`);
      this.mainForm = document.querySelector(`form#${productFormId}`);

      this.mainVariantInput = this.container.querySelector(
          'input[data-variant]:not([data-inline])'
      );

      // Set up colour inputs
      this.colourInputs = this.querySelectorAll('input[name="personalisation-colour"]');
      const checkedColour = this.querySelector('input[name="personalisation-colour"]:checked');
      this.colour = checkedColour ? checkedColour.value : '';
      this.colourLegendValue = this.querySelector('.radio__legend__value[data-option-value]');

      this.colourInputs.forEach(input => {
        input.addEventListener('change', () => {
          this.colour = input.value;
          if (this.colourLegendValue) {
            this.colourLegendValue.textContent = input.value;
          }
        });
      });

      // Set up font inputs
      this.fontInputs = this.querySelectorAll('input[name="personalisation-font"]');
      const checkedFont = this.querySelector('input[name="personalisation-font"]:checked');
      this.font = checkedFont ? checkedFont.value : '';
      this.fontLegendValue = this.querySelector('.radio__fieldset:not(.radio__fieldset--swatches) .radio__legend__value[data-option-value]');

      if (this.fontLegendValue && this.font) {
        this.fontLegendValue.textContent = this.font;
      }

      this.fontInputs.forEach(input => {
        input.addEventListener('change', () => {
          this.font = input.value;
          if (this.fontLegendValue) {
            this.fontLegendValue.textContent = input.value;
          }
        });
      });

      // Parse main product JSON from attribute
      const mainProductData = this.getAttribute('data-main-product');
      if (mainProductData) {
        this.mainProductJson = JSON.parse(mainProductData);
        this.resolveMainVariants();
      } else {
        console.warn('ProductPersonalisation: could not find main product JSON');
        return;
      }

      if (!this.toggle || !this.details) {
        console.warn('ProductPersonalisation: could not find toggle or details');
        return;
      }

      if (!this.mainVariantInput) {
        console.warn('ProductPersonalisation: could not find main variant input');
        return;
      }

      this.toggle.addEventListener('change', this.toggleDetails.bind(this));

      document.addEventListener(
          'theme:personalisation:add-to-cart',
          this.addToCart.bind(this)
      );

      document.addEventListener('theme:product:added', () => {
        this.resetPersonalisationToggle();
      });

      document.addEventListener("DOMContentLoaded", async () => {
        const giftNoteInCart = await this.giftNoteInCart();
        this.orDivider.style.display = (giftNoteInCart)? 'none' : 'block';
      })

    } catch(e) {
      console.error('ProductPersonalisation connectedCallback failed:', e);
    }
  }

  resolveMainVariants() {
    const personalisationOptionIndex = this.mainProductJson.options.findIndex(
        (opt) => opt.toLowerCase() === 'personalisation'
    );

    if (personalisationOptionIndex === -1) {
      console.warn('ProductPersonalisation: could not find Personalisation option on main product');
      return;
    }

    const optionKey = `option${personalisationOptionIndex + 1}`;

    const textVariant = this.mainProductJson.variants.find(
        (v) => v[optionKey] === 'Text'
    );

    const noPersonalisationVariant = this.mainProductJson.variants.find(
        (v) => v[optionKey] !== 'Text'
    );

    if (!textVariant || !noPersonalisationVariant) {
      console.warn('ProductPersonalisation: could not resolve main product variants');
      return;
    }

    this.personalisationOptionIndex = personalisationOptionIndex;
    this.textPersonalisationValue = textVariant[optionKey];
    this.noPersonalisationValue = noPersonalisationVariant[optionKey];
  }

  // Finds the variant matching `personalisationValue` on the Personalisation
  // option while keeping every other option (e.g. Size) at its current value,
  // so toggling personalisation doesn't reset unrelated option selections.
  findTargetVariant(personalisationValue) {
    const optionKey = `option${this.personalisationOptionIndex + 1}`;
    const currentVariant = this.mainProductJson.variants.find(
        (v) => v.id === Number(this.mainVariantInput.value)
    );

    const matchingCurrentOptions = currentVariant && this.mainProductJson.variants.find((v) => {
      if (v[optionKey] !== personalisationValue) return false;
      return this.mainProductJson.options.every((_, index) => {
        const key = `option${index + 1}`;
        return key === optionKey || v[key] === currentVariant[key];
      });
    });

    return matchingCurrentOptions || this.mainProductJson.variants.find(
        (v) => v[optionKey] === personalisationValue
    );
  }

  async toggleDetails() {
    this.isToggled = this.toggle.checked;
    const giftInCart = await this.giftNoteInCart();

    if (this.isToggled) {
      this.details.style.display = 'block';
      this.switchMainVariant(this.textPersonalisationValue);
      this.giftNoteElement.style.display = 'none';
      this.orDivider.style.display = 'none';
    } else {
      this.details.style.display = 'none';
      this.removePersonalisationProperties();
      this.switchMainVariant(this.noPersonalisationValue);
      if(!giftInCart) {
        this.giftNoteElement.style.display = 'block';
        this.orDivider.style.display = 'block';
      }

    }
  }

  switchMainVariant(personalisationValue) {
    if (!this.mainVariantInput || personalisationValue == null || this.personalisationOptionIndex === null) return;

    const optionKey = `option${this.personalisationOptionIndex + 1}`;
    const targetVariant = this.findTargetVariant(personalisationValue);
    if (!targetVariant) return;

    // Find or create a hidden options[Personalisation] input on the main form
    const productFormId = this.getAttribute(attributes.productFormID);
    const mainForm = document.querySelector(`form#${productFormId}`);

    let optionInput = document.querySelector(
        'input[name="options[Personalisation]"]:not([data-inline])'
    );

    if (!optionInput && mainForm) {
      optionInput = document.createElement('input');
      optionInput.type = 'hidden';
      optionInput.name = 'options[Personalisation]';
      optionInput.setAttribute('data-single-option-selector', '');
      optionInput.setAttribute('data-index', optionKey);
      mainForm.appendChild(optionInput);
    }

    if (optionInput) {
      optionInput.value = targetVariant[optionKey];
      optionInput.dispatchEvent(new Event('change', { bubbles: true }));
    }

    // Also update the variant ID input directly as fallback
    this.mainVariantInput.value = targetVariant.id;
    this.mainVariantInput.dispatchEvent(new Event('change', { bubbles: true }));

    // Update SelloutVariants option value
    const personalisationOptionInput = this.productForm.querySelector(
        '[data-personalisation-option-value]'
    );
    if (personalisationOptionInput) {
      personalisationOptionInput.value = targetVariant[optionKey];
    }
  }

  addToCart(event) {
    const hasText =
        this.text &&
        this.text.value !== '' &&
        this.text.value.trim() !== '';

    if (this.isToggled && hasText) {
      this.injectPersonalisationProperties();
    } else {
      this.removePersonalisationProperties();
    }

    document.dispatchEvent(
        new CustomEvent('theme:cart:add', {
          detail: { button: event.detail.button },
          bubbles: false,
        })
    );
  }

  injectPersonalisationProperties() {
    this.setProperty('Text', this.text.value.trim());
    this.setProperty('Colour', this.colour || '');
    this.setProperty('Font', this.font || '');
  }

  removePersonalisationProperties() {
    const productFormId = this.getAttribute(attributes.productFormID);
    const mainForm = document.querySelector(`form#${productFormId}`);
    if (!mainForm) return;

    ['Text', 'Colour', 'Font'].forEach((name) => {
      const existing = mainForm.querySelector(`input[name="properties[${name}]"]`);
      if (existing) existing.remove();
    });
  }

  setProperty(name, value) {
    const productFormId = this.getAttribute(attributes.productFormID);
    const mainForm = document.querySelector(`form#${productFormId}`);
    if (!mainForm) return;

    let input = mainForm.querySelector(`input[name="properties[${name}]"]`);
    if (!input) {
      input = document.createElement('input');
      input.type = 'hidden';
      input.name = `properties[${name}]`;
      mainForm.appendChild(input);
    }
    input.value = value;
  }

  disconnectedCallback() {
    if (this.toggle) {
      this.toggle.removeEventListener('change', this.toggleDetails.bind(this));
    }
    document.removeEventListener(
        'theme:personalisation:add-to-cart',
        this.addToCart.bind(this)
    );
  }

  async giftNoteInCart() {
    try {
      const response = await fetch('/cart.js');
      const cart = await response.json();

      return cart.items.some(
          item => item.product_id === this.GIFT_NOTE_PRODUCT_ID
      );
    } catch (error) {
      console.error('Error checking gift note in cart:', error);
      return false;
    }
  }

  resetPersonalisationToggle() {
    this.toggle.checked = false;
    this.toggleDetails();
  }
}

customElements.define('product-personalisation', ProductPersonalisation);